export const LocumsMarginCalcSections = {
    CANDIDATE: 'candidateSection',
    MARGIN_SETUP: 'marginSetup',
    ADDITIONAL_RATES: 'additionalRates',
    RTO_DATES: 'rtoDates',
    MARGIN_NOTES: 'marginNotes',
    EXPENSES: 'expenses'
} as const;
